export const PRISMA_CONNECT = "connect";
export const PRISMA_DISCONNECT = "disconnect";
export const PRISMA_CREATE = "create";
export const PRISMA_DELETE = "delete";
export const PRISMA_UPDATE = "update";
